const getLastSrcsetUrl = (srcset: { [key: string]: string }): string => {
  const sizes = Object.keys(srcset)
  const lastSize = sizes[sizes.length - 1]
  return srcset[lastSize]
}

const buildSrcsetString = (srcset: { [key: string]: string }): string => {
  return Object.entries(srcset)
    .map(([size, url]) => `${url} ${size}`)
    .join(", ")
}

export { getLastSrcsetUrl, buildSrcsetString }
